import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/system')({
  component: RouteComponent,
})

export const SystemRoute = Route

function RouteComponent() {
  return <div>Hello "/_app/system"!</div>
}
